import { Component, OnInit } from '@angular/core';
import { MasterService } from 'src/app/services/master/master.service';
import { ImportFilesDialogService } from 'src/app/_utils/import-files-dialog/import-files-dialog.service';
import { BaseComponent } from '../../base.component';
@Component({
  selector: 'app-menumaster',
  templateUrl: './menumaster.component.html',
  styleUrls: ['./menumaster.component.css']
})
export class MenumasterComponent extends BaseComponent implements OnInit {
  public menuObj: any = [];
  cp = 1;
  ord = true;
  colname: "Name";
  text;
  today: number = Date.now();
  constructor(
    private master: MasterService,
    private ImportFilesDialogService: ImportFilesDialogService,
  ) {
    super();
  }

  chgord(col) {
    this.ord = !this.ord
    this.colname = col
  }

  ngOnInit() {
    this.getMenuData();
    this.MenuLogData()
  }
  MenuLogData() {
    let menuLogs = {
      log_type:"Menu Master View" ,
      log_name:"Menu Master View" ,
      log_description:"Menu Master View" ,
      moduleid:1 ,
      moduleitemid:7,
      per_id:14
    }
    this.logs.addNewLogs(menuLogs).subscribe(data => {
     // console.log(data);

    }, error => {
     // console.log(error);
    });

}
  getMenuData() {
    let self = this;
    this.master.getMenu().subscribe(data => {
      self.menuObj = data;

    }, error => {
     // console.log(error);
    });
  }
  deleteMenu(id) {
    let obj = {
      id: id
    }
    this.confirmationDialogService.confirm('PLEASE CONFIRM', 'Are you sure you want to Delete ?', 'Yes', 'No')
      .then((confirmed) => {
        if (confirmed) {
          this.ngxSpinnerService.show();
          this.master.delMenu(obj).subscribe(data => {
            if (data.status) {
              this.getMenuData();
              setTimeout(() => {
                this.toastrService.success("Deleted Successfully");
              }, 1000)
            } else {
            }
            this.ngxSpinnerService.hide();
          }, error => {
           // console.log(error);
          });
        }
      }).catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
  }
  editMenu(id) {
    this.router.navigate(['/corporate/addnewmenu'], { queryParams: { menu_id: id } });
  }
  updateStatus(event, id) {
    event.preventDefault();
    let obj = this.menuObj.find(element => {
      //console.log(element.get_master_company_type.company_type_id)
      if (element.get_master_menu.menuid === id) {
        return true;
      }
    });
    obj = obj.get_master_menu;
    this.confirmationDialogService.confirm('PLEASE CONFIRM', 'Are you sure you want to change the status?', 'YES', 'NO')
      .then((confirmed) => {
        if (confirmed) {
          this.ngxSpinnerService.show();
          obj.isactive = !obj.isactive;
          this.master.updateMenu(obj).subscribe(data => {
            this.toastrService.success("Menu Master Status Changed Successfully");
            this.getMenuData();
            this.ngxSpinnerService.hide();
          });
        }
        // else {
        //   this.master.updateMenu(obj).subscribe(data => {
        //     this.toastrService.success("Status Changed Successfully");
        //     this.getMenuData();
        //   });
        // }
      }).catch(() => {
       // console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
      });
  }
  setValue(event) {
    let self = this;
    let url = event.target.src;
    if (url.indexOf("master_images") > 0) {
      url = url.substring(url.indexOf("master_images"), url.length)
      if (!this.isUrlValid(url)) {
        let awsUrl = self.master.getUrlfile(url);
        event.target.src = self.isUrlValid(awsUrl) ? awsUrl : '../../../assets/custom/images/broken.png';
      } else {
        event.target.src = '../../../assets/custom/images/broken.png';
      }
    } else {
      event.target.src = '../../../assets/custom/images/broken.png';
    }
    event.target.onerror = null;
  }
  isUrlValid(userInput) {
    return /(https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/i.test(userInput);
  }
  importFile() {
    let self = this;
    self.ImportFilesDialogService.confirm('Please Choose the File Path ', `../../../assets/margo-import-files/margo-menu-import.csv`, 'addingMenuBulk')
      .then(data => {
      //  console.log(data);
        self.getMenuData();
      })
      .catch(err => {
      //  console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
      })
  }
  exportFile() {
    let tablename = {
      "tableName": "master_menu_tbl"
    }
    this.master.exportBulk(tablename).subscribe(dataFile => {
      if (dataFile.status) {
        let selBox = document.createElement('a');
        var att = document.createAttribute("href");
        att.value = dataFile.file;
        var att1 = document.createAttribute("download");
        selBox.setAttributeNode(att);
        selBox.setAttributeNode(att1);
        document.body.appendChild(selBox);
        selBox.click();
      }
    }, err => {
      this.toastrService.error(err.message);
    });
  }
}
